var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-page"},[_c('div',{staticClass:"l-container"},[_c('h1',{staticClass:"status-page__title"},[_vm._v("Статус заказа")]),_c('status-order',{attrs:{"status-order-id":_vm.statusOrderId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }